export const formatTime = (timestamp: number) => {
  // 处理秒级时间戳(10位)→ 转换为毫秒级(13位)
  if (timestamp.toString().length === 10) {
    timestamp = timestamp * 1000;
  }

  const date = new Date(timestamp);

  // 提取年月日时分
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  // 拼接格式化字符串
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}